export const viewList = [{
    name:             'Day',
    type:             'day',
    groupOrientation: 'horizontal'
}, {
    name:             '3 Days',
    type:             'day',
    intervalCount:    3,
    groupOrientation: 'horizontal'
},
{
    name:             'Work Week',
    type:             'workWeek',
    groupOrientation: 'horizontal'
},
{
    name:             'Week',
    type:             'week',
    groupOrientation: 'horizontal'
},
{
    name:             'Month',
    type:             'month',
    groupOrientation: 'horizontal'
},
{
    name:             'Timeline',
    type:             'timelineDay',
    groupOrientation: 'vertical'
},
{
    name:             '3 Day Timeline',
    type:             'timelineDay',
    intervalCount:    3,
    groupOrientation: 'vertical'
},
{
    name:             'Work Week Timeline',
    type:             'timelineWorkWeek',
    groupOrientation: 'vertical'
},
{
    name:             'Week Timeline',
    type:             'timelineWeek',
    groupOrientation: 'vertical'
},
{
    name:             'Month Timeline',
    type:             'timelineMonth',
    groupOrientation: 'vertical'
},
{
    name:             'Agenda',
    type:             'agenda',
    groupOrientation: 'horizontal'
}
];
